import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { HiCake } from "react-icons/hi2";
// @ts-ignore
import { IconWrapper } from "@viuti/recursos";
import styles from "./BirthdayBell.module.css";

const BirthdayBell = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const today = new Date().toISOString().split("T")[0];

  const fetchCount = async () => {
    try {
      const token = localStorage.getItem("access_token") || "";
      const r = await fetch("/api/v2/customers/birthday-count", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!r.ok) return;
      const j = await r.json();
      setCount(j?.data?.count || 0);
    } catch {
      /* silencioso */
    }
  };

  useEffect(() => {
    fetchCount();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setShowTooltip(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (count === 0) return null;

  const handleClick = () => {
    setShowTooltip(false);
    navigate(`/clientes?birthday=${today}&t=${Date.now()}`);
  };

  return (
    <div className={styles.container} ref={ref}>
      <button
        className={styles.trigger}
        onClick={() => setShowTooltip(!showTooltip)}
        aria-label="Cumpleaños"
      >
        <IconWrapper icon={HiCake} size={18} color="#F59E0B" />
        <span className={styles.badge}>{count > 9 ? "9+" : count}</span>
      </button>
      {showTooltip && (
        <div className={styles.tooltip} onClick={handleClick}>
          <span className={styles.tooltipIcon}>🎂</span>
          <span className={styles.tooltipText}>
            {count === 1 ? "1 cliente cumple años hoy" : `${count} clientes cumplen años hoy`}
          </span>
          <span className={styles.tooltipAction}>Ver →</span>
        </div>
      )}
    </div>
  );
};

export default BirthdayBell;
